import { render, staticRenderFns } from "./mine.vue?vue&type=template&id=4840870c&scoped=true&"
import script from "./mine.vue?vue&type=script&lang=js&"
export * from "./mine.vue?vue&type=script&lang=js&"
import style0 from "./mine.vue?vue&type=style&index=0&id=4840870c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4840870c",
  null
  
)

export default component.exports